module.exports = "/_next/static/images/b5b64ca39fa4aa1a14546b83f09fe857-debit-card-lg.svg";